import { render, staticRenderFns } from "./rebot.vue?vue&type=template&id=5b0b7f6c&scoped=true&"
import script from "./rebot.vue?vue&type=script&lang=js&"
export * from "./rebot.vue?vue&type=script&lang=js&"
import style0 from "./rebot.vue?vue&type=style&index=0&id=5b0b7f6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0b7f6c",
  null
  
)

export default component.exports